export const AUTH_URL = {
  baseRoot:'/api/v1',
  root: '/api/v1/customer',
  storeCustomer: '/api/v1/storecustomer',
  verify: '/api/v1/verifystoreemail',
  findCustomer: '/api/v1/findstorecustomer',
  login: '/login',
  logout: '/logout',
  storeLoc: '/store/location',
  countries:{
    list:'/region/country'
  },
  store: {
    list : '/accounts/getallaccountsforuser',
    change: '/changestore/check'
  },
  tax: {
    validate : '/api/v1/tax/validate/address'
  },
  // Test
  pwr: {
    api_key : '',
    locale : '',
    merchant_group_id : '',
    merchant_id : ''
  }, 
  
  version: {
    num : '26.06.24'
  }
  
};

export default {AUTH_URL};



// WEBPACK FOOTER //
// ./src/app/auth/constants.js